/** A single entry in a tooltip list. Use `label` to override the marker (e.g. '?'); otherwise items are auto-marked. */
export interface TooltipItem {
  label?: string;
  text: string;
}

/** Content for an info ("i") popup. Renders an optional description and/or a list. */
export interface TooltipContent {
  /** Popup heading. */
  title?: string;
  /** Intro paragraph shown above any list. */
  description?: string;
  /** List entries. Plain strings get an auto marker; use `TooltipItem` to override it. */
  items?: (string | TooltipItem)[];
  /** Numbered list when true (default); bulleted when false. */
  ordered?: boolean;
}
